var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtpIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 62,
    fill: "#F6F7FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.8503 76.8946C89.8515 72.057 86.1709 68.0131 81.3546 67.5602C76.5382 67.1072 72.1683 70.3941 71.2676 75.1471L42.4597 74.3657L42.7759 79.315C42.7759 79.315 38.6681 88.7933 60.2576 91.3187V100.899H85.2162V84.9706C88.0841 83.2912 89.8476 80.2181 89.8503 76.8946Z",
    fill: "url(#paint0_linear_925_53409)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7651 79.5227C43.7651 79.5227 39.8315 88.5994 60.5069 91.021V100.199H84.4094V75.8928L43.4581 74.7824L43.7651 79.5227Z",
    fill: "#8CC63F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7112 41.6451C54.4137 43.6925 51.7064 44.3077 49.6516 43.0221L36.818 34.5652C34.7706 33.2678 34.1554 30.5604 35.441 28.5056C36.7382 26.4611 39.4421 25.8462 41.496 27.1286L54.3296 35.5855C56.3786 36.8815 56.9959 39.5891 55.7112 41.6451Z",
    fill: "url(#paint1_linear_925_53409)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0002 41.1834C53.7942 43.0865 51.2777 43.6584 49.3676 42.4634L37.4343 34.5963C35.5312 33.3903 34.9593 30.8739 36.1543 28.9638C37.3603 27.0608 39.8768 26.4889 41.7868 27.6838L53.7178 35.5463C55.6245 36.7517 56.1978 39.2718 55.0002 41.1834Z",
    fill: "#8CC63F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8722 86.1802C84.8296 86.1802 88.8484 82.1614 88.8484 77.2039C88.8484 72.2465 84.8296 68.2277 79.8722 68.2277C74.9147 68.2277 70.8959 72.2465 70.8959 77.2039C70.8959 82.1614 74.9147 86.1802 79.8722 86.1802Z",
    fill: "#8CC63F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2563 18H43.8701C43.0892 18 42.4562 18.633 42.4562 19.4139V83.7564C42.4562 84.5373 43.0892 85.1703 43.8701 85.1703H78.2563C79.0371 85.1703 79.6702 84.5373 79.6702 83.7564V19.4139C79.6702 18.633 79.0371 18 78.2563 18Z",
    fill: "url(#paint2_linear_925_53409)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5915 18.9084H44.5327C43.6632 18.9084 42.9583 19.6132 42.9583 20.4827V82.6899C42.9583 83.5594 43.6632 84.2643 44.5327 84.2643H77.5915C78.461 84.2643 79.1658 83.5594 79.1658 82.6899V20.4827C79.1658 19.6132 78.461 18.9084 77.5915 18.9084Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1584 20.5474C69.942 21.9795 68.7132 23.0397 67.2648 23.0439H54.7601C53.3122 23.0391 52.084 21.9791 51.8677 20.5474H45.2425C44.8777 20.5474 44.5278 20.6918 44.2697 20.9496C44.0117 21.2074 43.8667 21.5572 43.8667 21.922V81.2483C43.8667 81.6131 44.0111 81.963 44.2689 82.2211C44.5268 82.4791 44.8766 82.6241 45.2414 82.6241H76.8828C77.2476 82.6241 77.5975 82.4797 77.8556 82.2219C78.1136 81.9641 78.2586 81.6142 78.2586 81.2495V21.9232C78.2586 21.5584 78.1142 21.2084 77.8564 20.9504C77.5986 20.6924 77.2488 20.5474 76.884 20.5474H70.1584Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9171 21.3287H57.3097C57.1822 21.3287 57.0789 21.4321 57.0789 21.5596V21.6023C57.0789 21.7298 57.1822 21.8331 57.3097 21.8331H64.9171C65.0446 21.8331 65.148 21.7298 65.148 21.6023V21.5596C65.148 21.4321 65.0446 21.3287 64.9171 21.3287Z",
    fill: "#DBDBDB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8619 21.9067C67.0696 21.9067 67.238 21.7384 67.238 21.5307C67.238 21.323 67.0696 21.1547 66.8619 21.1547C66.6543 21.1547 66.4859 21.323 66.4859 21.5307C66.4859 21.7384 66.6543 21.9067 66.8619 21.9067Z",
    fill: "#DBDBDB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6744 78.7875C83.0693 79.39 81.2815 77.691 80.679 75.0871L74.6933 52.8605C74.0977 50.2465 75.7245 47.6422 78.3348 47.0306C80.9488 46.4351 83.5532 48.0619 84.1647 50.6722L89.0493 73.4724C89.6518 76.0774 88.2783 78.185 85.6744 78.7875Z",
    fill: "url(#paint3_linear_925_53409)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4931 51.2162C82.9852 49.0182 80.7917 47.648 78.5937 48.1559C76.3956 48.6637 75.0255 50.8573 75.5333 53.0553L81.0374 76.8773C81.5453 79.0753 83.7389 80.4455 85.9369 79.9376C88.1349 79.4298 89.5051 77.2362 88.9972 75.0382L83.4931 51.2162Z",
    fill: "#8CC63F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8104 97.1959H54.6458V105.16H88.8104V97.1959Z",
    fill: "url(#paint4_linear_925_53409)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.887 98.1193H55.5692V104.352H87.887V98.1193Z",
    fill: "#48A14D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7296 65.4887C49.4479 67.5118 46.7729 68.1198 44.7427 66.8496L36.1358 61.2805C34.1128 59.9988 33.5047 57.3239 34.775 55.2936C36.0567 53.2706 38.7316 52.6626 40.7618 53.9328L49.3688 59.5019C51.3918 60.7836 51.9998 63.4585 50.7296 65.4887Z",
    fill: "url(#paint5_linear_925_53409)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.569 77.2767C47.2758 79.3182 44.5765 79.932 42.5278 78.6502L37.1965 74.7628C35.155 73.4697 34.5412 70.7704 35.823 68.7217C37.1161 66.6801 39.8154 66.0664 41.8642 67.3482L47.1954 71.2367C49.2363 72.5298 49.85 75.2282 48.569 77.2767Z",
    fill: "url(#paint6_linear_925_53409)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.0621 61.9673C66.7953 61.9673 71.443 57.3196 71.443 51.5863C71.443 45.8531 66.7953 41.2054 61.0621 41.2054C55.3288 41.2054 50.6811 45.8531 50.6811 51.5863C50.6811 57.3196 55.3288 61.9673 61.0621 61.9673Z",
    fill: "url(#paint7_linear_925_53409)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0621 61.3567C66.4582 61.3567 70.8325 56.9823 70.8325 51.5863C70.8325 46.1903 66.4582 41.8159 61.0621 41.8159C55.6661 41.8159 51.2918 46.1903 51.2918 51.5863C51.2918 56.9823 55.6661 61.3567 61.0621 61.3567Z",
    fill: "#8CC63F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8215 50.2821L60.485 53.6408L65.6754 46.0081L67.5083 47.5351L60.485 56.6949L55.2945 50.8938L56.8215 50.2821Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1384 76.987C46.9324 78.89 44.4159 79.4619 42.5059 78.267L37.5336 74.6474C35.6305 73.4414 35.0586 70.9249 36.2535 69.0148C37.4596 67.1118 39.976 66.5399 41.8861 67.7348L46.8573 71.3613C48.7565 72.5667 49.3284 75.0781 48.1384 76.987Z",
    fill: "#8CC63F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2563 65.1828C49.0503 67.0859 46.5338 67.6578 44.6238 66.4629L36.5259 61.2228C34.6228 60.0167 34.051 57.5003 35.2459 55.5902C36.4519 53.6872 38.9684 53.1153 40.8784 54.3102L48.9763 59.5503C50.8794 60.7563 51.4513 63.2728 50.2563 65.1828Z",
    fill: "#8CC63F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9549 53.7562C51.6669 55.7881 48.9799 56.3986 46.9403 55.1228L36.0331 48.0209C34.0012 46.7329 33.3907 44.0459 34.6665 42.0064C35.9545 39.9745 38.6415 39.3639 40.6811 40.6398L51.5883 47.7416C53.6202 49.0296 54.2307 51.7166 52.9549 53.7562Z",
    fill: "url(#paint8_linear_925_53409)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3755 53.3869C51.1695 55.2899 48.653 55.8618 46.743 54.6669L36.5271 48.0152C34.6241 46.8092 34.0522 44.2927 35.2471 42.3826C36.4531 40.4796 38.9696 39.9077 40.8796 41.1026L51.0944 47.7543C52.9978 48.96 53.5702 51.4765 52.3755 53.3869Z",
    fill: "#8CC63F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_925_53409",
    x1: 66.1567,
    y1: 100.904,
    x2: 66.1567,
    y2: 67.5201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_925_53409",
    x1: 45.5749,
    y1: 43.695,
    x2: 45.5749,
    y2: 26.4581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_925_53409",
    x1: 61.0632,
    y1: 85.1691,
    x2: 61.0632,
    y2: 17.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_925_53409",
    x1: 81.8794,
    y1: 78.9076,
    x2: 81.8794,
    y2: 46.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_925_53409",
    x1: 71.7304,
    y1: 105.158,
    x2: 71.7304,
    y2: 97.1936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_925_53409",
    x1: 42.7505,
    y1: 67.5132,
    x2: 42.7505,
    y2: 53.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_925_53409",
    x1: 42.1966,
    y1: 79.3196,
    x2: 42.1966,
    y2: 66.6776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_925_53409",
    x1: 61.0621,
    y1: 61.9673,
    x2: 61.0621,
    y2: 41.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_925_53409",
    x1: 43.8101,
    y1: 55.7934,
    x2: 43.8101,
    y2: 39.9773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtpIcon);
export default __webpack_public_path__ + "static/media/otpIcon.f0fd34f63a03480e83ea9191719337f2.svg";
export { ForwardRef as ReactComponent };